// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"bd628a30","196":"bd09140b","233":"e45876ef","414":"a1081690","450":"f8ded495","463":"a84273bc","845":"f5df9367","852":"08cb457a","865":"e53ea24a","891":"5fe451f2","903":"77fe7949"}[chunkId] + ".chunk.js";
};